export function isInsideMasterEnv (spaceContext) {
  return spaceContext.getEnvironmentId() === 'master';
}



// WEBPACK FOOTER //
// ./src/javascripts/utils/EnvironmentUtils.es6.js